import {type PropsWithChildren, createContext, use, useMemo} from 'react'

export type EmptyContextType = boolean
export const EmptyContext = createContext<EmptyContextType | undefined>(undefined)

export function EmptyProvider({children, isEmpty}: PropsWithChildren<{isEmpty?: boolean}>) {
  const value = useMemo(() => isEmpty ?? false, [isEmpty])
  return <EmptyContext value={value}>{children}</EmptyContext>
}

export function useEmpty(): EmptyContextType {
  const context = use(EmptyContext)
  if (typeof context === 'undefined') {
    throw new Error('useEmpty must be used within a EmptyProvider')
  }
  return context
}
